define('formkit/view/form.object/compare.form.object.view',['require','exports','module','uikit/uikit','./base.form.object.view','../../behavior/sync.form.object.heights.behavior','../../behavior/hide.not.progressively.disclosed.unchanged.objects.behavior'],function(require, exports, module){
  var UIKit = require('uikit/uikit');
  var BaseFormObjectView      = require('./base.form.object.view');
  var SyncFormObjectHeightsBehavior = require('../../behavior/sync.form.object.heights.behavior');
  var HideNotProgressivelyDisclosedUnchangedObjectsBehavior = require('../../behavior/hide.not.progressively.disclosed.unchanged.objects.behavior');

  var CompareFormObjectView = BaseFormObjectView.extend({
    className: 'ui segment compare formObject',

    template: function() {
      return '<ui name="compareMessageView"/><ui name="contentView" />'
    },

    behaviors: {
      SyncFormObjectHeightsBehavior: {
        behaviorClass: SyncFormObjectHeightsBehavior
      },
      HideNotProgressivelyDisclosedUnchangedObjectsBehavior: {
        behaviorClass: HideNotProgressivelyDisclosedUnchangedObjectsBehavior
      }
    },

    internalViewOptions: BaseFormObjectView.extendInternalViewOptions({
      compareMessageView: function() {
        return {
          type: UIKit.Text,
          text: this.form.compareHiddenMessage,
          visible: this.form.util.isProgressivelyHidden(this.model)
        }
      },
      contentView: function() {
        return {
          visible: !this.form.util.isProgressivelyHidden(this.model)
        }
      }
    }),

    updateAttributes: function() {
      if (this.form.util.isAdded(this.model)) {
        this.addClass('added', true);
      }
      else if (this.form.util.isRemoved(this.model)) {
        this.addClass('removed', true);
      }
      else if (this.form.util.isMovedChanged(this.model)) {
        this.addClass('moved-changed', true);
      }
    }
  });

  module.exports = CompareFormObjectView;
});

